import { render, staticRenderFns } from "./ShareYourMomentsComponent.vue?vue&type=template&id=884696b8&scoped=true"
import script from "./ShareYourMomentsComponent.vue?vue&type=script&lang=js"
export * from "./ShareYourMomentsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884696b8",
  null
  
)

export default component.exports